/* Pooch — carousel ka auto side-scroll (web + mobile dono).
   Horizon ke apne <slideshow-component> ka next() use karta hai, koi hack nahi.
   Client kuch nahi karta: collection me jitne product honge, sab apne aap chalenge.
   - hover / touch / focus par ruk jata hai
   - aakhir par pahunch ke wapas pehle slide par
   - tab chhupa ho ya section screen par na ho to ruka rehta hai
   - "reduce motion" on ho to bilkul nahi chalta                                */
(function () {
  /* 3 Oct: Ankit ne bola carousel bahut tez chal raha hai -> 3400 se 6000 kiya.
     Teeno section (Bestsellers, Shop by Concern, CbnVmk) ab 6 second par. */
  var STEP_MS = 6000;

  /* sirf ye sections — product card ke andar wali image gallery ko chhedna nahi hai */
  var SECTIONS = [
    '[id$=__product_list_fa6P9H]',
    '[id$=__carousel_concern]',
    '[id$=__carousel_CbnVmk]'
  ];

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function attach(root) {
    /* section-level slideshow — product-card ke andar wale chhod do */
    var shows = Array.prototype.filter.call(
      root.querySelectorAll('slideshow-component'),
      function (el) { return !el.closest('product-card'); }
    );
    shows.forEach(function (show) {
      if (show.dataset.poochAuto === '1') return;
      if (typeof show.next !== 'function') return;
      var slides = show.querySelector('slideshow-slides');
      if (!slides || slides.children.length < 2) return;
      if (slides.scrollWidth <= slides.clientWidth + 8) return;   // sab pehle se dikh rahe hain
      show.dataset.poochAuto = '1';

      var paused = false, timer = null, stuck = 0;

      function tick() {
        if (paused || document.hidden) return;
        var before = slides.scrollLeft;
        try { show.next(); } catch (e) { return; }
        setTimeout(function () {
          if (Math.abs(slides.scrollLeft - before) < 4) {
            stuck++;
            if (stuck >= 1) {                       // aakhir aa gaya -> shuru se
              stuck = 0;
              if (typeof show.select === 'function') { try { show.select(0); } catch (e) {} }
              else slides.scrollTo({ left: 0, behavior: 'smooth' });
            }
          } else { stuck = 0; }
        }, 700);
      }

      function start() { if (!timer) timer = setInterval(tick, STEP_MS); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (e) {
        show.addEventListener(e, function () { paused = true; }, { passive: true });
      });
      ['mouseleave', 'focusout'].forEach(function (e) {
        show.addEventListener(e, function () { paused = false; }, { passive: true });
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { en.isIntersecting ? start() : stop(); });
        }, { threshold: 0.2 }).observe(show);
      } else {
        start();
      }
    });
  }

  function run() {
    if (reduce) return;
    SECTIONS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(attach);
    });
  }

  var t;
  function debounced() { clearTimeout(t); t = setTimeout(run, 400); }
  document.addEventListener('DOMContentLoaded', debounced);
  window.addEventListener('load', debounced);
  document.addEventListener('shopify:section:load', debounced);
  window.addEventListener('resize', debounced);
  debounced();
})();
